import { observable, action, runInAction } from 'mobx'
import Api from '@api/easyChat'
import { getObjValue, switchCase } from '@hlj/hlj-utils'
import { message } from 'hljd'
import { isHotelMerchant } from '@util'

const HOME_SPEECH = {
  name: '店铺主页',
  key: 'home_speech',
  value: '',
  visible: true,
  disabled: false,
  reason: '',
  status: ''
}

const PACKAGE_SPEECH = {
  name: '套餐详情页',
  key: 'package_speech',
  value: '',
  visible: true,
  disabled: false,
  reason: '',
  status: ''
}

const EXAMPLE_SPEECH = {
  name: '案例详情页',
  key: 'example_speech',
  value: '',
  visible: true,
  disabled: false,
  reason: '',
  status: ''
}

const BANQUET_HALL_SPEECH = {
  name: '婚宴厅详情',
  key: 'banquet_hall_speech',
  value: '',
  visible: true,
  disabled: false,
  reason: '',
  status: ''
}

const BANQUET_MENU_SPEECH = {
  name: '婚宴菜单详情',
  key: 'banquet_menu_speech',
  value: '',
  visible: true,
  disabled: false,
  reason: '',
  status: ''
}

class Store {
  @observable template = []
  @observable chatType = []
  @observable visible = false
  @observable disabled = true
  @observable timer = null
  @observable active = 0
  @observable example_speech = {}
  @observable home_speech = {}
  @observable package_speech = {}
  @observable banquet_hall_speech = {} // 酒店宴会厅
  @observable banquet_menu_speech = {} // 婚宴菜单详情

  constructor() {
    this.chatType = isHotelMerchant()
      ? [HOME_SPEECH, BANQUET_HALL_SPEECH, BANQUET_MENU_SPEECH]
      : [HOME_SPEECH, PACKAGE_SPEECH, EXAMPLE_SPEECH]
  }

  @action
  onFocus = index => () => {
    this.chatType = this.chatType.map((item, i) => {
      item.visible = !(i === index)
      return item
    })
  }
  @action
  onBlur = index => () => {
    this.timer = setTimeout(() => {
      Object.assign(this.chatType[index], {
        visible: true
      })
    }, 500)
  }
  @action
  setContent = (idx, type, record) => {
    clearTimeout(this.timer)
    this.timer = null
    Object.assign(this.chatType[idx], {
      disabled: this[type]
        ? getObjValue(this[type], 'speech') === record.value
        : false,
      value: record.value,
      visible: true
    })
  }
  @action
  changeField = (index, type) => e => {
    Object.assign(this.chatType[index], {
      disabled: this[type]
        ? getObjValue(this[type], 'speech') === e.target.value
        : false,
      value: e.target.value.substring(0, 100)
    })
  }
  @observable count = 10
  @observable countDownID = null
  @action
  countDown = () => {
    this.visible = true
    this.disabled = true
    this.count = 10
    this.countDownID = setInterval(() => {
      this.count--
      if (this.count < 0) {
        clearInterval(this.countDownID)
        this.disabled = false
        return (this.countDownID = null)
      }
    }, 1000)
  }
  @action
  cancel = () => {
    this.open()
  }
  /**
   * 检查是否开通
   */
  @action
  check = async () => {
    let {
      data: { active, pend_word }
    } = await Api.chatCheckApi()
    const {
      example_speech,
      home_speech,
      package_speech,
      banquet_hall_speech,
      banquet_menu_speech
    } =
      pend_word || {}
    runInAction(() => {
      this.active = active
      this.home_speech = home_speech
      this.example_speech = example_speech
      this.package_speech = package_speech
      this.banquet_hall_speech = banquet_hall_speech
      this.banquet_menu_speech = banquet_menu_speech
      this.chatType = this.chatType.map(item => {
        if (item.key === 'home_speech') {
          item.value = getObjValue(home_speech, 'speech') || ''
          item.reason = getObjValue(home_speech, 'reason') || ''
          item.status = getObjValue(home_speech, 'status') || ''
          item.disabled = +getObjValue(home_speech, 'status') === 2
        } else if (item.key === 'example_speech') {
          item.value = getObjValue(example_speech, 'speech') || ''
          item.reason = getObjValue(example_speech, 'reason') || ''
          item.status = getObjValue(example_speech, 'status') || ''
          item.disabled = +getObjValue(example_speech, 'status') === 2
        } else if (item.key === 'package_speech') {
          item.value = getObjValue(package_speech, 'speech') || ''
          item.reason = getObjValue(package_speech, 'reason') || ''
          item.status = getObjValue(package_speech, 'status') || ''
          item.disabled = +getObjValue(package_speech, 'status') === 2
        } else if (item.key === 'banquet_hall_speech') {
          item.value = getObjValue(banquet_hall_speech, 'speech') || ''
          item.reason = getObjValue(banquet_hall_speech, 'reason') || ''
          item.status = getObjValue(banquet_hall_speech, 'status') || ''
          item.disabled = +getObjValue(banquet_hall_speech, 'status') === 2
        } else if (item.key === 'banquet_menu_speech') {
          item.value = getObjValue(banquet_menu_speech, 'speech') || ''
          item.reason = getObjValue(banquet_menu_speech, 'reason') || ''
          item.status = getObjValue(banquet_menu_speech, 'status') || ''
          item.disabled = +getObjValue(banquet_menu_speech, 'status') === 2
        }
        return item
      })
    })
  }
  /**
   * 获取模板
   */
  @action
  getTpl = async () => {
    let {
      data: { list }
    } = await Api.templateApi()
    runInAction(() => {
      this.template = (list || []).map((item, key) => ({
        id: key,
        value: item
      }))
    })
  }
  /**
   * 开通
   */
  @action
  open = async () => {
    let { success } = await Api.chatActiveApi()
    if (success) {
      this.check()
      this.visible = false
    }
  }
  /**
   * 编辑问候语
   */
  getParams = type => {
    const { chatType } = this
    const params = {
      home_speech: { home_speech: chatType[0].value }
    }

    if (isHotelMerchant()) {
      params.banquet_hall_speech = { banquet_hall_speech: chatType[1].value }
      params.banquet_menu_speech = { banquet_menu_speech: chatType[2].value }
    } else {
      params.package_speech = { package_speech: chatType[1].value }
      params.example_speech = { example_speech: chatType[2].value }
    }

    return switchCase(type, params)
  }
  @action
  edit = type => async () => {
    let params = this.getParams(type)
    if (Object.values(params)[0].trim() === '') {
      return message.warn('问候语不能为空')
    }
    let { success } = await Api.chatEditApi(params)
    if (success) {
      this.check()
      message.success('保存成功')
    }
  }
}

export default Store
